/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $GraphicsBox, CanBeSignals} from '@gongxigames/framework/core/fragments/BuilderY';
import {$ButtonRuby} from '@gongxigames/framework/slotV2/ui/ui-ruby/JSX/ButtonRuby';
import {$RubyUIText} from '@gongxigames/framework/slotV2/ui/ui-ruby/JSX/RubyUIText';
import {COLOR_POPUP_BG2} from '@gongxigames/framework/slotV2/ui/ui-ruby/CONSTANTS';

export const HEADER_HEIGHT = '108px';

export type BaseHeaderProps = {
    localeID: string;
    onCancel?: () => any;
};

export type HeaderProps = CanBeSignals<BaseHeaderProps>;

export const $Header: FC<HeaderProps> = (props) => {
    const {localeID} = props;

    return <$GraphicsBox
        name='header'
        responsive={{box: {width: '100%', height: HEADER_HEIGHT}}}
        responsiveBoxSize
        boxColor={COLOR_POPUP_BG2}
    >
        <$RubyUIText
            localeID={localeID}
            stylePreset='POPUP_HEADER'
            responsive={{box: {x: '50%', y: '50%'}}}
        />
        <$ButtonRuby
            hitArea='no_bg'
            responsive={{
                box: {y: '50%', x: '100%'},
                translate: {x: '-54px'},
            }}
            icon='btn_icon_close'
            action={props.onCancel}
        />
    </$GraphicsBox>;
};
